module.exports = __webpack_public_path__ + "img/item_Story_15.04955ff8.jpeg";